import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CrossCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossCircleIconPath";
import styles from "./CloseReason.module.css";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

type CloseReasonProps = {
  text: string | Loading;
};

const NON_COLLAPSABLE_WHITESPACE = "\u00A0";

function CloseReason({ text }: CloseReasonProps) {
  return (
    <FixaText textStyle="Body.M" className={styles["root"]}>
      <FixaSSRIcon className={styles["icon"]} paths={CrossCircleIconPath} />
      {isLoading(text) ? NON_COLLAPSABLE_WHITESPACE : text}
    </FixaText>
  );
}

export default CloseReason;
